import api from "./axios";

const storeSession = (data) => {
  const { token } = data;
  if (token) {
    localStorage.setItem("token", token);
  }
  return data;
};

export const login = async (credentials) => {
  localStorage.removeItem("token")
  localStorage.removeItem("authenticatedToken")
  // withCredentials so the browser SENDS the deviceTrust cookie. Without it
  // the trusted-device check never sees a token and every login gets the
  // picker, with no error to explain why.
  const res = await api.post("/user/login", credentials, {
    withCredentials: true,
  });
  return storeSession(res.data);
};
// export const login = async (credentials) => {
//   localStorage.removeItem("token")
//   localStorage.removeItem("authenticatedToken")
//   const res = await api.post("/user/login", credentials);
//   return storeSession(res.data);
// };

export const sendTwoFactorCode = async ({ challengeToken, medium }) => {
  const res = await api.post("/mfa/send", { challengeToken, medium });
  return res.data;
};

export const verifyTwoFactorCode = async ({ challengeToken, code, rememberDevice }) => {
  // withCredentials so the browser ACCEPTS the deviceTrust cookie coming back.
  const res = await api.post(
    "/mfa/verify",
    { challengeToken, code, rememberDevice },
    { withCredentials: true },
  );
  return storeSession(res.data);
};

export const register = (data) => api.post("/user/register", data);

export const signOut = async() => {
  try {
    await api.post("/user/v2/logout", {all: true});
  } catch (error) {
    console.error("Logout error:", error);
  }
  localStorage.removeItem("token");
  // login() clears both keys; signOut only cleared one, so a stale
  // authenticatedToken survived until the next sign-in.
  localStorage.removeItem("authenticatedToken");
  return Promise.resolve();
};

export const loginById = (user_id) => api.post(`user/${user_id}/login`)